module.exports = __webpack_public_path__ + "static/media/293713.fc288d1c.png";